<script>
  const ENDPOINT_URL = `/api/v1/tephra_snippets/theme_available_snippets?theme_id=${CodeEditor.Main.themeId()}`
  import { onMount } from "svelte";
  import { fade } from 'svelte/transition';
  import Fuse from "fuse.js";
  export let label
  let remote_snippets = null
  let snippets = null
  let typingTimer;
  let doneTypingInterval = 800;
  let searching = false
  let addedSnippets = []
  let status = "loading"

  const options = { keys: ['path']}
  const fuse = new Fuse([], options)

  onMount(async () => {
    remote_snippets = await (await fetch(ENDPOINT_URL, {credentials: "include"})).json();
    snippets = remote_snippets;
    status = "stale"
    fuse.setCollection(remote_snippets)
  });


  function searchSnippets({target}) {
    const {value} =  target
    if (!searching) searching = true
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      const searchTerm = value.trim().toLowerCase()
      if (!searchTerm.length) snippets = remote_snippets
      else snippets = fuse.search(searchTerm)
      if (searching) searching = false
    } ,doneTypingInterval)
  }

  const addSnippet = (id) => ()=> {
    CodeEditor.TephraManager.addSnippetToTheme(id);
    addedSnippets = addedSnippets.concat([id])
  }

  $:snippets = snippets && snippets.slice(0, 100)

</script>


<div id={label} class="tephra-view" class:searching={status === "loading" || searching}>
  <input disabled={status === "loading"} on:input={searchSnippets} id="tephra-search" autocomplete="off" type="text" placeholder="Find tephra snippets" >
  <div class="result-list">
    {#if status === "loading"}
      <p class="text">Fetching snippets ...</p>
    {:else if !snippets.length}
      <p class="text">Nothing here !</p>
    {:else}
      {#each snippets as { id, path, reference, design_mode }, i}
        {#if !addedSnippets.includes(id)} 
          <div class="result-item" snippet-id={id} transition:fade>
            <div>
              <div class="result-item-title">
                <p>{reference.replace(/.*\//, "")}</p>
                {#if design_mode }
                  <span class='badge'>Site builder</span>
                {/if}
              </div>
              <small class="family">{path}/</small>
            </div>
            
            <button on:click={addSnippet(id)} >Add</button>
            </div>
          {/if}
      {/each}
      <p class="text">Showing {snippets.length} out of {remote_snippets.length} reuslts. Search for more accurate results</p>
    {/if}
  </div>
</div>


<style>
  .text {
    color: #9aa2b1
  }
  .tephra-view {
    padding: 10px;
    height: 100%;
    position: relative;
  }
  .tephra-view.searching:before {
    content: "";
    position: absolute;
    background: #e57b2a;
    width: 100%;
    height: 3px;
    top: 4px;
    left: 0;
    display: block;
    animation: loader 1s ease-in-out infinite;
  }
  .tephra-view input {
    background-color: #191818;
    border-color: transparent;
    color: #fff;
    box-shadow: none;
    padding: 8px;
    display: block;
    width: 100%;
  }
  .tephra-view .result-item {
    display: flex;
    justify-content: space-between;
    color: #fff;
    margin: 10px 0;
    background: #121822;
    align-items: center;
    padding: 10px;
        
  }     
  .tephra-view .result-item .family {
    color: #888;
    font-size: 10px;
    font-style: italic;
    margin-left: 10px;
  }
  
  .tephra-view .result-item p {
    margin: 0;
  }

  .tephra-view .result-item button {
    background: #e57b2a;
    border: none;
    font-size: 11px;
    cursor: pointer;
  }
  .tephra-view .result-item button:hover {
    background: #e7a16b;
  }

  .tephra-view .result-item .badge {
    font-size: 8px;
    border: solid #84c89f70 1px;
    line-height: 1;
    padding: 2px 3px;
    border-radius: 3px;
    margin-left: 10px;
    color: #84c89f90;
    font-weight: 400;
    margin-left: 10px;
  }
  .tephra-view .result-item .result-item-title {
    display: flex;
    align-items: center;
  }


  @keyframes loader {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(100%);
    }
  }
  .result-list {
    overflow: auto;
    height: 100%;
    height: -webkit-fill-available;
    padding: 20px 0 80px;
  }
</style>